import React from 'react';
import {Grid, Card, CardContent, Typography} from '@mui/material';
import {styled} from '@mui/system';

const CustomCard = styled(Card)(({theme}) => ({
    borderRadius: '20px',
    textAlign: 'center',
    padding: theme.spacing(2),
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    height: '100%', // Đảm bảo các card có chiều cao là 100% của container Grid item
    display: 'flex',
    flexDirection: 'column', // Sắp xếp các phần tử con theo chiều dọc
}));

const CardImage = styled('img')({
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    marginBottom: '20px',
});

const InfoSection = () => {
    return (
        <div style={{textAlign: 'center', margin: '50px 35px 50px 0'}}>
            <Typography
                variant="h6"
                style={{
                    margin: '0 0 50px 0',
                    color: '#1a1a1a',
                    fontSize: '35px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                }}
            >
                Our Team
            </Typography>
            <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} md={2.4}>
                    <CustomCard>
                        <CardContent style={{flexGrow: 1}}>
                            <CardImage
                                src="https://res.cloudinary.com/drvydie5q/image/upload/v1720679610/Dynamic%20folders/t69ekrnjtn38lvwo9r9u.png"
                                alt="Handpicked Destination"
                            />
                            <Typography variant="h6" style={{fontWeight: 'bold'}}>
                                Anh Vu
                            </Typography>
                            <Typography variant="body2" style={{marginTop: '10px'}}>
                                Anh Vu is a dedicated professional in Information Technology, leveraging expertise in
                                software development and system integration to drive technological innovation and
                                efficiency.
                            </Typography>
                        </CardContent>
                    </CustomCard>
                </Grid>
                <Grid item xs={12} md={2.4}>
                    <CustomCard>
                        <CardContent style={{flexGrow: 1}}>
                            <CardImage
                                src="https://res.cloudinary.com/drvydie5q/image/upload/v1720679643/Dynamic%20folders/bwoj7v5agjxvzykcwg4d.png"
                                alt="Best Price Guaranteed"
                            />
                            <Typography variant="h6" style={{fontWeight: 'bold'}}>
                                Nhu Huy
                            </Typography>
                            <Typography variant="body2" style={{marginTop: '10px'}}>
                                Nhu Huy is a seasoned professional in Hospitality Management, dedicated to delivering
                                exceptional guest experiences and optimizing hotel operations for superior efficiency.
                            </Typography>
                        </CardContent>
                    </CustomCard>
                </Grid>
                <Grid item xs={12} md={2.4}>
                    <CustomCard>
                        <CardContent style={{flexGrow: 1}}>
                            <CardImage
                                src="https://res.cloudinary.com/drvydie5q/image/upload/v1720718550/Dynamic%20folders/ptsond5wsevko3tpnp39.png"
                                alt="24/7 Customer Service"
                            />
                            <Typography variant="h6" style={{fontWeight: 'bold'}}>
                                My Diem
                            </Typography>
                            <Typography variant="body2" style={{marginTop: '10px'}}>
                                My Diem is a dedicated professional in Hospitality Management, committed to delivering
                                exceptional guest experiences and efficiently managing hotel operations.
                            </Typography>
                        </CardContent>
                    </CustomCard>
                </Grid>
                <Grid item xs={12} md={2.4}>
                    <CustomCard>
                        <CardContent style={{flexGrow: 1}}>
                            <CardImage
                                src="https://res.cloudinary.com/drvydie5q/image/upload/v1720679666/Dynamic%20folders/l5jy6b4cygejub0fixqj.png"
                                alt="24/7 Customer Service"
                            />
                            <Typography variant="h6" style={{fontWeight: 'bold'}}>
                                Khanh Vu
                            </Typography>
                            <Typography variant="body2" style={{marginTop: '10px'}}>
                                Khanh Vu is a skilled professional in Mechatronics, specializing in integrating
                                mechanical and electrical engineering with computer science to innovate and optimize
                                automated systems.
                            </Typography>
                        </CardContent>
                    </CustomCard>
                </Grid>
                <Grid item xs={12} md={2.4}>
                    <CustomCard>
                        <CardContent style={{flexGrow: 1}}>
                            <CardImage
                                src="https://res.cloudinary.com/drvydie5q/image/upload/v1720679355/Dynamic%20folders/gixruemquepbb32xklhn.png"
                                alt="24/7 Customer Service"
                            />
                            <Typography variant="h6" style={{fontWeight: 'bold'}}>
                                Hoang Minh
                            </Typography>
                            <Typography variant="body2" style={{marginTop: '10px'}}>
                                Hoang Minh brings a wealth of expertise to Hospitality Management, focusing on
                                delivering exceptional guest experiences and optimizing hotel operations with
                                efficiency.
                            </Typography>
                        </CardContent>
                    </CustomCard>
                </Grid>
            </Grid>
        </div>
    );
};

export default InfoSection;
